import { AVOverviewTemplateTypeName, getEnumStringOptions } from 'tno-core';

export const templateTypeOptions = getEnumStringOptions(AVOverviewTemplateTypeName);
